module.exports = __webpack_public_path__ + "static/media/Tiger5963_3c.09a6c039.svg";